import axios from 'axios';
import { firestore } from '../../firebase';
import { collection, query, where, getDocs } from "firebase/firestore";

// Get user profile data based on handle (case-insensitive)
export const fetchUserProfile = async (handle) => {
  if (!handle) return { user: "User not found" };
  
  try {
    // First try exact match using API
    const result = await axios.get(`/user/${handle}`);
    return result.data;
  } catch (err) {
    if (err.response?.data?.error === "User not found") {
      // If exact match fails, try case-insensitive search in Firestore
      try {
        
        
        // Query users collection
        const usersRef = collection(firestore, "users");
        const usersSnapshot = await getDocs(usersRef);
        
        // Find user with case-insensitive match
        const matchingUser = usersSnapshot.docs.find(
          doc => doc.data().handle.toLowerCase() === handle.toLowerCase()
        );
        
        if (matchingUser) {
          
          // Try API again with exact handle
          const exactHandle = matchingUser.data().handle;
          const exactResult = await axios.get(`/user/${exactHandle}`);
          return exactResult.data;
        } else {
          
          return { user: "User not found" };
        }
      } catch (firestoreErr) {
        console.error("Error in Firestore search:", firestoreErr);
        return { user: "User not found" };
      }
    }
    
    throw err;
  }
}

// Get user's own profile data
export const fetchAuthenticatedUserProfile = async () => {
  return axios
      .get('/user')
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        
  
        throw err;
      });
}

// Update user's own profile data
export const updateUserProfile = async (data) => {
  return axios
    .post('/user', data)
    .then((res) => {
        return res;
    })
    .catch((err) => {
      

      throw err;
    });
};